<app-dashboard-host
  [dashboardId]="dashboardId"
  [langCode]="'en'">
</app-dashboard-host>